import { PureComponent, createRef } from "react";
import { connect } from "react-redux";
import { mapStateToProps } from "@/store";

class VideoPlayer extends PureComponent {
    constructor(props) {
        super(props);
        this.videoRef = createRef();
    }

    componentDidMount() {
        this.loadVideo();
        window.addEventListener("keydown", this.handleKeyDown);
    }

    componentDidUpdate(previousProps) {
        if (previousProps.videoSrc !== this.props.videoSrc) {
            this.loadVideo();
        }
    }

    componentWillUnmount() {
        this.destroyHls();
        window.removeEventListener("keydown", this.handleKeyDown);
    }

    destroyHls = () => {
        this.hls?.destroy();
        this.hls = null;
    };

    loadVideo = async () => {
        const { videoSrc } = this.props;
        const video = this.videoRef.current;
        this.destroyHls();
        if (!video || !videoSrc) return;

        if (video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = videoSrc;
            video.play().catch(() => undefined);
            return;
        }
        const { default: Hls } = await import("hls.js");
        if (
            videoSrc !== this.props.videoSrc ||
            video !== this.videoRef.current
        ) {
            return;
        }
        if (Hls.isSupported()) {
            this.hls = new Hls({ enableWorker: true });
            this.hls.loadSource(videoSrc);
            this.hls.attachMedia(video);
            this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                video.play().catch(() => undefined);
            });
            return;
        }
        video.src = videoSrc;
    };

    handleKeyDown = (event) => {
        if (event.key === "Escape") this.closeVideo();
    };

    closeVideo = () => {
        const { dispatch } = this.props;
        this.videoRef.current?.pause();
        this.destroyHls();
        dispatch({
            type: "UPDATE_VIDEOSRC",
            src: null,
            poster: null,
        });
    };

    render() {
        const { videoSrc, videoPoster } = this.props;
        if (!videoSrc) return null;

        return (
            <div
                className="mod-video"
                role="dialog"
                aria-modal="true"
                aria-label="视频播放器"
                onMouseDown={(event) => {
                    if (event.target === event.currentTarget) this.closeVideo();
                }}
            >
                <div className="mod-video__content">
                    <video
                        ref={this.videoRef}
                        playsInline
                        poster={videoPoster}
                        autoPlay
                        controls
                        preload="metadata"
                    >
                        当前浏览器不支持视频播放。
                    </video>
                    <button
                        type="button"
                        className="close"
                        aria-label="关闭视频"
                        onClick={this.closeVideo}
                    >
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M6.5 6.5l11 11M17.5 6.5l-11 11"
                                stroke="currentColor"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(VideoPlayer);
